/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('zcsHideWhenProduction', zcsHideWhenProduction);

zcsHideWhenProduction.$inject = ['Environment'];
function zcsHideWhenProduction(Environment) {
  return {
    restrict: 'A',
    link(scope, elem, attrs) {
      elem.css({display: 'none'});
      scope.Environment = Environment;
      Environment.get()
        .then(environment => {
          if(environment === 'production') {
            elem.css({display: 'none'});
          } else {
            elem.css({display: 'block'});
          }
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/hide_when_production/hide_when_production.js